import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import {
  Box,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextareaAutosize,
  styled,
  Button,
  Typography,
  Switch,
  IconButton,
  Paper,
  Checkbox,
  ToggleButtonGroup,
  ToggleButton,
  Table,
  TableContainer,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  InputAdornment,
  Popper,
  ClickAwayListener,
  MenuList,
  Popover,
  FormLabel,
  Autocomplete,
} from "@mui/material";

import styles from "./index.module.css";
import "./index.css";
import {
  Add as AddIcon,
  CalendarToday as CalendarTodayIcon,
  TextSnippet as PictureAsPdfIcon,
  PictureAsPdf,
  DeleteOutlined as DeleteOutlineIcon,
  Close as CloseIcon,
  NavigateBefore as NavigateBeforeIcon,
  NavigateNext as NavigateNextIcon,
  VisibilityOff,
  Visibility,
  Edit as EditIcon,
  Delete as DeleteIcon,
  CalendarMonthOutlined,
  MoreHoriz,
  Label,
  Search,
  ExpandLess,
  ExpandMore,
  Check,
  SearchOffOutlined,
} from "@mui/icons-material";
import AppDatePicker from "../../components/Common/AppDatePicker";
import { FilePdfOutlined, DeleteOutlined } from "@ant-design/icons";
import { LoadingOutlined, CheckCircleOutlined } from "@ant-design/icons";
import Calendericon from "../../assets/icons/Calendar with interaction.svg";
import AssigneeModal from "../../components/TaskFilter/AssigneeModal";
import del from "../../assets/images/delete.svg";

import theme from "../../theme/theme";

import moment from "moment";
import PhoneInput from "react-phone-input-2";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByPlaceId } from "react-google-places-autocomplete";

import countries from "./countries";
import {
  FetchActiveUser,
  insertDocToS3,
  updateAndDeleteCompanyCar,
  updateAndDeleteContractType,
  updateAndDeleteEmployeeType,
  updateAndDeleteIdsType,
  updateAndDeleteReasons,
  deleteCompanyCar,
  deleteContractType,
  deleteEmployeeType,
  deleteIdsType,
  deleteReasons,
  fetchIdsType,
  fetchEmployeeType,
  fetchContractType,
  fetchCompanyCar,
  fetchReasons,
  AddJobtypes,
  UpdateJobtypes,
  DeleteJobtypes,
  FetchUserTitles,
  AddUpdateUserTitles,
  DeleteUserTitles,
  DeleteUserTimeOff,
  fetchUserCertification,
  coWorkerCertification,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import { API_URL } from "../../redux/constants/type";
import axios from "axios";
import { Modal } from "antd";

// const { TextArea } = Input;

const userid = window.localStorage.getItem("userid");

const CustomTextField = ({ label, ...props }) => (
  <TextField
    fullWidth
    variant="outlined"
    label={label}
    InputLabelProps={{ shrink: true }}
    {...props}
    autoComplete="new-password"
  />
);

const CustomSelect = ({ label, options, value, ...props }) => {
  const [internalValue, setInternalValue] = React.useState(value || "");

  React.useEffect(() => {
    if (value !== undefined) {
      setInternalValue(value);
    }
  }, [value]);

  return (
    <StyledFormControl fullWidth sx={{ outline: 0 }}>
      <InputLabel sx={{ outline: 0 }}>{label}</InputLabel>
      <Select
        sx={{ outline: 0 }}
        label={label}
        value={internalValue}
        {...props}
      >
        {options &&
          options.length > 0 &&
          options.map((type, index) => {
            return (
              <MenuItem value={type?.value} key={index}>
                {type?.label}
              </MenuItem>
            );
          })}
      </Select>
    </StyledFormControl>
  );
};

const PhoneInputMui = ({ label, value, ...props }) => (
  <Box
    fullWidth
    {...props}
    sx={{
      position: "relative",
      border: "1px solid #e4e7eb",
      paddingX: 1,

      borderRadius: 1,
      paddingY: 1.5,
    }}
  >
    <FormLabel
      sx={{
        fontSize: 11,
        fontWeight: 400,
        position: "absolute",
        top: "-10px",
        left: 10,
        backgroundColor: "white",
        paddingX: 1,
      }}
    >
      {label}
    </FormLabel>
    <PhoneInput
      country={"nl"}
      enableSearch={true}
      className="flag-inputcontact border-black"
      value={value}
    />
  </Box>
);

const AddressAutoComplete = ({ label, onChange, value, ...props }) => {
  const [zipcode, setZipcode] = useState("");
  const [fullAddress, setFullAddress] = useState("");

  // ASC address with postal code start
  const handleAddressSelect = async (address) => {
    try {
      const { place_id } = address;
      const results = await geocodeByPlaceId(place_id);

      if (!results.length) return;

      const { formatted_address, address_components } = results[0];
      const postalCode =
        address_components.find((x) => x.types.includes("postal_code"))
          ?.long_name || "";

      setFullAddress(formatted_address); // Store full Google address.
      // setZipCode(postalCode); // Store only postal code.
      onChange(formatted_address);
      console.log("final address", formatted_address);
    } catch (error) {
      console.error("Error fetching address details:", error);
    } finally {
      console.log("Address API Call Completed");
    }
  };
  // ASC address with postal code end

  return (
    <Box
      fullWidth
      {...props}
      sx={{
        position: "relative",
        border: "1px solid #e4e7eb",
        paddingX: 1,
        borderRadius: 1,
        paddingY: 1.5,
      }}
    >
      <FormLabel
        sx={{
          fontSize: 11,
          fontWeight: 400,
          position: "absolute",
          top: "-10px",
          left: 10,
          backgroundColor: "white",
          paddingX: 1,
        }}
      >
        {label}
      </FormLabel>
      <GooglePlacesAutocomplete
        style={{ width: "100%" }}
        debounce={800}
        placeholder=""
        //   onSelect={(e) => {
        //     handleAddressSelect(e);
        //     onChange(e.description);
        //   }}
        //   initialValue={value}
        // />
        // {zipcode && (
        //   <Box mt={2}>
        //     <strong>Zipcode:</strong> {zipcode}
        //   </Box>
        // )}
        onSelect={(address) => handleAddressSelect(address)}
        initialValue={value}
      />
      {/* {fullAddress && (
        <Box mt={1} sx={{ fontSize: 14, color: "#555" }}>
          <strong>Selected Address:</strong> {fullAddress}
        </Box>
      )} */}
    </Box>
  );
};

const SearchableSelect = ({
  onChange,
  options,
  placeholder,
  label,
  parentValue,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [value, setValue] = useState("");

  useEffect(() => {
    if (parentValue) setValue(parentValue);
    else if (placeholder) setValue(placeholder);
  }, [placeholder, value, parentValue]);

  const filteredLanguages = options.filter((lang) =>
    lang.label.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Co-Workers").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const styles = {
    container: {
      position: "relative",
      width: "100%",
      height: "100%",
    },
    button: {
      display: "flex",
      alignItems: "center",
      height: "100%",
      justifyContent: "space-between",
      width: "100%",
      padding: "8px 16px",
      textAlign: "left",
      backgroundColor: "white",
      border: `1px solid ${isOpen ? "#00246a" : "#d1d5db"} `,
      borderRadius: "8px",
      boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
      cursor: "pointer",
      position: "relative",
    },
    label: {
      position: "absolute",
      top: "-10px",
      left: 10,
      padding: "0 8px",
      backgroundColor: "white",
      color: "#6a7280",
      fontSize: 11,
    },
    placeholder: {
      color: "#b1b7c1",
      fontSize: 14,
    },
    chevron: {
      width: "20px",
      height: "20px",
      transition: "transform 0.2s",
      transform: isOpen ? "rotate(180deg)" : "rotate(0)",
    },
    dropdown: {
      position: "absolute",
      zIndex: 10,
      width: "100%",
      marginTop: "4px",
      backgroundColor: "white",
      border: "1px solid #d1d5db",
      borderRadius: "4px",
      boxShadow:
        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    },
    searchContainer: {
      padding: "8px",
      borderBottom: "1px solid #d1d5db",
    },
    searchInput: {
      width: "100%",
      padding: "4px 8px",
      paddingLeft: "28px",
      backgroundColor: "#f3f4f6",
      border: "none",
      borderRadius: "4px",
    },
    searchIcon: {
      position: "absolute",
      left: "16px",
      top: "16px",
      width: "16px",
      height: "16px",
      color: "#9ca3af",
    },
    list: {
      maxHeight: "240px",
      overflowY: "auto",
      padding: "4px 0",
    },
    listItem: {
      padding: "8px 16px",
      cursor: "pointer",
    },
  };

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <div style={styles.container}>
        <button onClick={() => setIsOpen(!isOpen)} style={styles.button}>
          <span style={styles.label}>{label}</span>
          <span style={styles.placeholder}>{value}</span>
          <svg
            style={styles.chevron}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M6 9l6 6 6-6" />
          </svg>
        </button>

        {isOpen && (
          <div style={styles.dropdown}>
            <div style={styles.searchContainer}>
              <svg
                style={styles.searchIcon}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input
                type="text"
                // placeholder="Search"
                placeholder={t("Select ")}
                style={styles.searchInput}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <ul style={styles.list}>
              {filteredLanguages.map((lang, index) => (
                <li
                  key={index}
                  style={{
                    ...styles.listItem,
                    backgroundColor: index % 2 === 0 ? "#f9fafb" : "white",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#f3f4f6")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor =
                      index % 2 === 0 ? "#f9fafb" : "white")
                  }
                  onClick={() => {
                    setIsOpen(false);
                    setValue(lang.label);
                    onChange(lang.value);
                  }}
                >
                  {lang.label}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
};

const CustomDate = ({ label, value, onChange, future = false }) => {
  const styles = {
    container: {
      position: "relative",
      border: `1px solid #e4e7eb`,
      padding: 10,
      borderRadius: "8px",
    },
    label: {
      position: "absolute",
      top: "-10px",
      left: 10,
      padding: "0 8px",
      backgroundColor: "white",
      color: "#6a7280",
      fontSize: 11,
      maxWidth: "70%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    icon: {
      position: "absolute",
      top: "30%",
      left: 20,
      zIndex: 10,
    },
  };
  const [calendarIsOpen, setCalendarIsOpen] = useState(false);

  return (
    <div style={styles.container}>
      <label style={styles.label}>{label}</label>
      <img
        src={Calendericon}
        alt="calender"
        style={styles.icon}
        onClick={() => setCalendarIsOpen((p) => !p)}
      />
      <AppDatePicker
        open={calendarIsOpen}
        onOpenChange={(open) => setCalendarIsOpen(open)}
        // isError={dateError}
        // error={setDateError}
        inputClassNames={"ms-3x"}
        dateFormat="dd/MM/yyyy"
        className="calender-icon-date border-black ps-5"
        style={{ borderBottom: "none" }}
        onSelect={(d, event) => {
          event.preventDefault();
        }}
        selected={value}
        onChange={(e) => {
          onChange(e);
        }}
        isDisabledForFuture={future}
      />
    </div>
  );
};

const CustomDropDown = ({
  label,
  onSelect,
  selectedOption,
  setSelectedOption,
  options,
  editOption,
  deleteOption,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const [newOption, setNewOption] = useState({ label: "", value: "" });
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [optionEnter, setOptionEnter] = useState([]);
  const [editParticularOption, setEditParticularOption] = useState([]);

  const toggleDropdown = () => setIsOpen(!isOpen);
  const handleOptionClick = (option) => {
    setSelectedOption(
      option.label.length > 20 ? option.label.slice(0, 20) : option.label,
    );
    onSelect(option.value);
    setIsOpen(false);
  };

  const handleAddNewClick = () => {
    setIsAddingNew(true);
    setNewOption("");
  };

  const handleNewOptionChange = (option, e) => {
    if (Object.keys(option).length > 0) {
      setNewOption({ label: e.target.value, value: option.value });
    } else {
      setNewOption({ label: e.target.value, value: null });
    }
  };

  const handleNewOptionSubmit = (option, e) => {
    if (newOption.label.trim()) {
      editOption(newOption);
      setSelectedOption(newOption.label.trim());
      onSelect(newOption.value);
      setIsAddingNew(false);
      setIsOpen(false);
    }
  };

  const handleNewOptionCancel = (option, e) => {
    if (Object.keys(option).length > 0)
      setEditParticularOption(editParticularOption.map((opt) => false));
    else setIsAddingNew(false);
  };

  const styles = {
    container: {
      flexBasis: "48%",
      position: "relative",
    },
    label: {
      position: "absolute",
      top: "-10px",
      left: 8,
      fontSize: 11,
      color: "#666",
      marginBottom: "4px",
      backgroundColor: "white",
      padding: "0 10px",
    },
    select: {
      width: "100%",
      padding: "10px",
      border: "1px solid #ccc",
      borderRadius: "8px",
      backgroundColor: "white",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
      fontSize: 13,
    },
    arrow: {
      borderStyle: "solid",
      borderWidth: "0 2px 2px 0",
      display: "inline-block",
      padding: "3px",
      transform: isOpen ? "rotate(-135deg)" : "rotate(45deg)",
      transition: "transform 0.2s",
    },
    dropdown: {
      position: "absolute",
      top: "100%",
      left: 0,
      right: 0,
      backgroundColor: "white",
      border: "1px solid #ccc",
      borderTop: "none",
      borderRadius: "0 0 4px 4px",
      maxHeight: "300px",
      overflowY: "auto",
      boxShadow: "0px 5px 10px 0px rgba(0, 0, 0, 0.2)",
      zIndex: 1000,
    },
    option: (index) => {
      return {
        padding: "4px 10px",
        cursor: "pointer",
        fontSize: 12,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: optionEnter[index] && "#fafafa",
        color: optionEnter[index] && "#00246a",
      };
    },
    addNew: {
      padding: "10px",
      color: "#00246a",
      cursor: "pointer",
      fontWeight: 600,
      // borderTop: "1px solid #ccc",
      fontSize: 13,
    },
    newOption: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
    },
    newOptionInput: {
      width: "100%",
      padding: "10px",
      border: "none",
    },
    newOptionActions: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    icon: {
      height: "12px",
      width: "12px",
    },
  };

  useEffect(() => {
    if (options && options.length > 0) {
      setOptionEnter(new Array(options.length).fill(false));
      setEditParticularOption(new Array(options.length).fill(false));
    }
  }, [options]);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Co-Workers").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <div style={styles.container}>
        <div style={styles.label}>{label}</div>
        <div style={styles.select} onClick={toggleDropdown}>
          {/* <span>{selectedOption || "Select"}</span> */}
          <span>{selectedOption || t("Select ")}</span>
          <i style={styles.arrow}></i>
        </div>
        {isOpen && (
          <div style={styles.dropdown}>
            {Array.isArray(options) &&
              options.map((option, index) => (
                <div
                  key={index}
                  style={styles.option(index)}
                  onMouseEnter={() =>
                    setOptionEnter(
                      optionEnter.map((option, i) =>
                        i === index ? true : false,
                      ),
                    )
                  }
                  onMouseLeave={() =>
                    setOptionEnter(optionEnter.map((option, i) => false))
                  }
                >
                  {!editParticularOption[index] ? (
                    <div onClick={() => handleOptionClick(option)}>
                      {option.label}
                    </div>
                  ) : (
                    <div style={styles.newOption}>
                      <input
                        style={styles.newOptionInput}
                        type="text"
                        value={newOption.label}
                        onChange={handleNewOptionChange.bind(null, option)}
                        autoFocus
                      />
                      <div style={styles.newOptionActions}>
                        <Check
                          sx={{ height: 14, width: 14 }}
                          onClick={handleNewOptionSubmit.bind(null, option)}
                        />
                        <CloseIcon
                          sx={{ height: 14, width: 14 }}
                          onClick={handleNewOptionCancel.bind(null, option)}
                        />
                      </div>
                    </div>
                  )}
                  {optionEnter.length > 0 &&
                    optionEnter[index] &&
                    !editParticularOption[index] && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <EditIcon
                          style={styles.icon}
                          onClick={() => {
                            setEditParticularOption(
                              editParticularOption.map((opt, i) =>
                                i === index ? true : false,
                              ),
                            );
                            setNewOption(option);
                          }}
                        />
                        <img
                          src={del}
                          alt=""
                          style={styles.icon}
                          onClick={deleteOption.bind(null, option.value)}
                        />
                      </div>
                    )}
                </div>
              ))}
            {isAddingNew ? (
              <div style={styles.newOption}>
                <input
                  style={styles.newOptionInput}
                  type="text"
                  value={newOption.label}
                  onChange={handleNewOptionChange.bind(null, {})}
                  autoFocus
                />
                <div style={styles.newOptionActions}>
                  <Check
                    sx={{ height: 14, width: 14 }}
                    onClick={handleNewOptionSubmit.bind(null, {})}
                  />
                  <CloseIcon
                    sx={{ height: 14, width: 14 }}
                    onClick={handleNewOptionCancel.bind(null, {})}
                  />
                </div>
              </div>
            ) : (
              <div style={styles.addNew} onClick={handleAddNewClick}>
                {/* Add new... */}
                {t("Add New")}...
              </div>
            )}
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
};

export function PersonalInfoForm({
  personalForm,
  setPersonalForm,
  FetchLanguagesData,
  errors,
  setErrors,
  updateScreen,
  ascTakingDatafromChild,
}) {
  const dispatch = useDispatch();
  const [seePassword, setSeePassword] = useState(false);

  // User Title start.
  const { fetchUserTitleRes, addUpdateUserTitleRes, deleteUserTitleRes } =
    useSelector((state) => state.user);

  const [currentUserid, setCurrentUserid] = useState("");

  useEffect(() => {
    const id = localStorage.getItem("userid");
    setCurrentUserid(id);
  }, []);

  console.log("asc22 title", fetchUserTitleRes.data);
  const [selectedTitle, setSelectedTitle] = useState("");

  useEffect(() => {
    if (
      Object.keys(personalForm).length > 0 &&
      fetchUserTitleRes.data &&
      fetchUserTitleRes.data.length > 0
    ) {
      let filteredData = fetchUserTitleRes.data.find(
        (x) => x.userTitleId === personalForm.title,
      );
      setSelectedTitle(filteredData?.userTitleName);
    }
  }, [fetchUserTitleRes, personalForm]);

  useEffect(() => {
    if (personalForm.title) {
      // setSelectedTitle(personalForm.title);
    }
  }, []);

  useEffect(() => {
    dispatch(FetchUserTitles());
  }, [addUpdateUserTitleRes, deleteUserTitleRes]);
  // User Title end.

  const handleChange = (name, e) => {
    const existingFields = { ...personalForm };
    existingFields[name] = e.target.value;
    // ascTakingDatafromChild(e.target.value);
    ascTakingDatafromChild && ascTakingDatafromChild(e.target.value);

    if (name === "firstname") {
      // const fnames = e.target.value.split(" ");
      // const firstName = fnames[0];
      // fnames.shift();
      // const lastName = fnames.join(" ") || "";
      const fnames = e.target.value.trim().split(" ");
      const firstName = fnames[0] || "";
      const lastName = fnames.slice(1).join(" ") || "";

      // auto genrate initials from first name and last name
      existingFields.initials = fnames
        .filter(Boolean)
        .map((word) => word[0]?.toUpperCase())
        .join("");
    }

    setPersonalForm(existingFields);
  };

  useEffect(() => {
    if (!personalForm.language && FetchLanguagesData?.data?.data?.length > 0) {
      const existingFields = { ...personalForm };
      existingFields["language"] =
        FetchLanguagesData?.data?.data?.[0]?.languagename;
      setPersonalForm(existingFields);
    }
  }, [personalForm]);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Co-Workers").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  return (
    <Box sx={{ margin: "auto", paddingY: 2, marginTop: 1 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <CustomTextField
            // label="Full Name"
            label={t("Full Name")}
            // placeholder="Add a name"
            placeholder={t("Add a name")}
            value={personalForm.firstname}
            onChange={(e) => {
              handleChange("firstname", e);
              setErrors((prev) => {
                return { ...prev, firstName: false };
              });
            }}
          />

          {errors.firstName && (
            <Typography variant="caption1" color="red">
              {/* Please enter your full name ! */}
              {t("Please enter your valid email !")}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <CustomTextField
            // label="Email"
            label={t("Email")}
            // placeholder="example@company.com"
            placeholder={t("example@gmail.com")}
            value={personalForm.email}
            onChange={(e) => {
              if (updateScreen) return;
              else {
                const emailValue = e.target.value.toLowerCase().trim();
                const cleanEvent = {
                  ...e,
                  target: {
                    ...e.target,
                    value: emailValue,
                  },
                };
                // handleChange("email", e);
                handleChange("email", cleanEvent);
                // Email validation regex
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                setErrors((prev) => {
                  return {
                    ...prev,
                    email: false,
                    email: !emailRegex.test(emailValue),
                    alreadyExist: false,
                  };
                });
              }
            }}
          />
          {errors.email && (
            <Typography variant="caption1" color="red">
              {/* Please enter your valid email ! */}
              {t("Please enter your valid email !")}
            </Typography>
          )}
          {errors.alreadyExist && (
            <Typography variant="caption1" color="red">
              {/* This Email Id Already Exist ! */}
              {t("This Email Id Already Exis")}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <CustomTextField
            // label="Initials"
            label={t("Initials")}
            placeholder="Add initials"
            disabled
            value={personalForm.initials}
            onChange={(e) => {
              handleChange("initials", e);
              setErrors((prev) => {
                return { ...prev, initials: false };
              });
            }}
          />
          {errors.initials && (
            <Typography variant="caption1" color="red">
              {/* Initials required ! */}
              {t("Initials required")}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          {/* <CustomSelect
            label="Title"
            options={["Mr", "Mrs", "Ms", "Dr"].map((title) => {
              return { label: title, value: title };
            })}
            value={personalForm.title}
            onChange={(e) => handleChange("title", e)}
          /> */}

          <CustomDropDown
            // label="Title"
            label={t("Title")}
            onSelect={(option) =>
              handleChange("title", { target: { value: option } })
            }
            options={
              fetchUserTitleRes.data &&
              fetchUserTitleRes.data.length > 0 &&
              fetchUserTitleRes.data.map((title) => {
                return {
                  label: title.userTitleName,
                  value: title.userTitleId,
                };
              })
            }
            selectedOption={selectedTitle}
            setSelectedOption={setSelectedTitle}
            deleteOption={(id, option) => {
              dispatch(DeleteUserTitles(id));
            }}
            editOption={(option) => {
              // dispatch(
              //   AddUpdateUserTitles({
              //     userTitleId: option.value,
              //     userTitleName: option.label,
              //   })
              // );
              dispatch(AddUpdateUserTitles(option.value, option.label));
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <CustomTextField
            // label="Password"
            label={t("Password")}
            value={personalForm.password}
            placeholder="Add a password"
            onChange={(e) => {
              handleChange("password", e);
              setErrors((prev) => {
                return { ...prev, password: false };
              });
            }}
            // type={seePassword ? "text" : "password"}
            type={
              personalForm?.userid !== currentUserid
                ? "password"
                : seePassword
                  ? "text"
                  : "password"
            }
            disabled={personalForm?.userid !== currentUserid}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {seePassword ? (
                    <Visibility
                      sx={{ height: 20, width: 20, cursor: "pointer" }}
                      onClick={() => setSeePassword(false)}
                    />
                  ) : (
                    <VisibilityOff
                      sx={{ height: 20, width: 20, cursor: "pointer" }}
                      onClick={() => setSeePassword(true)}
                    />
                  )}
                </InputAdornment>
              ),
            }}
          />
          {errors.password && (
            <Typography variant="caption1" color="red">
              {/* Please enter password! */}
              {t("Please enter password!")}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <AddressAutoComplete
            // label="Address"
            label={t("Address")}
            onChange={(e) => handleChange("address", { target: { value: e } })}
            value={personalForm.address}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <PhoneInputMui
            // label="Business Telephone"
            label={t("Business Telephone")}
            placeholder="+31"
            value={personalForm.businessTelephone}
            onChange={(e) => handleChange("businessTelephone", e)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <PhoneInputMui
            // label="Personal Telephone"
            label={t("Personal Telephone")}
            placeholder="+31"
            value={personalForm.personalTelephone}
            onChange={(e) => handleChange("personalTelephone", e)}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6}>
              <CustomDate
                // label="Birthdate"
                label={t("Birthday ")}
                onChange={(e) =>
                  handleChange("dateofbirth", {
                    target: { value: e },
                  })
                }
                value={personalForm.dateofbirth}
                future={true}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <CustomTextField
                // label="Birth Place"
                label={t("Birth Place")}
                value={personalForm.birthPlace}
                onChange={(e) => handleChange("birthPlace", e)}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <CustomTextField
            // label="Personal Email"
            label={t("personal Email")}
            // placeholder="example@email.com"
            placeholder={t("example@gmail.com")}
            value={personalForm.personalEmail}
            onChange={(e) => handleChange("personalEmail", e)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6}>
              <SearchableSelect
                // label="Country of Birth"
                label={t("Country of Birth")}
                options={[...countries].map((title) => {
                  return { label: title.name, value: title.name };
                })}
                parentValue={personalForm.countryofBirth}
                onChange={(value) =>
                  handleChange("countryofBirth", { target: { value: value } })
                }
                // placeholder="Country"
                placeholder={t("Country")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <SearchableSelect
                // label="Nationality"
                label={t("nationality")}
                options={[...countries].map((title) => {
                  return { label: title.name, value: title.name };
                })}
                parentValue={personalForm.nationality}
                onChange={(value) =>
                  handleChange("nationality", { target: { value: value } })
                }
                // placeholder="Country"
                placeholder={t("Country")}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <PhoneInputMui
            // label="Emergency Contact"
            label={t("Emergency Contact")}
            placeholder="+31"
            value={personalForm.emergencyContact}
            onChange={(e) => handleChange("emergencyContact", e)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6}>
              <CustomSelect
                // label="Gender"
                label={t("Gender")}
                options={["Male", "Female", "Other"].map((title) => {
                  return { label: title, value: title };
                })}
                value={personalForm.gender}
                onChange={(e) => handleChange("gender", e)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <CustomSelect
                // label="Marital Status"
                label={t("Marital Status")}
                options={["Single", "Married", "Divorced"].map((title) => {
                  return { label: title, value: title };
                })}
                value={personalForm.maritalStatus}
                onChange={(e) => handleChange("maritalStatus", e)}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6}>
              <CustomTextField
                // label="Emergency Telephone"
                label={t("Emergency Telephone")}
                value={personalForm.emergencyTelephone}
                onChange={(e) => handleChange("emergencyTelephone", e)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <CustomSelect
                // label="Relation"
                label={t("Relation")}
                options={["Father", "Mother"].map((title) => {
                  return { label: title, value: title };
                })}
                value={personalForm.relation}
                onChange={(e) => handleChange("relation", e)}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <SearchableSelect
            placeholder="Type a destination language"
            options={
              FetchLanguagesData?.data?.data
                ? FetchLanguagesData?.data?.data?.map((lang) => {
                    return {
                      label: lang?.languagename,
                      value: lang?.languagename,
                    };
                  })
                : []
            }
            onChange={(value) =>
              handleChange("language", { target: { value: value } })
            }
            // label="Language"
            label={t("Language")}
            parentValue={
              FetchLanguagesData?.data?.data && personalForm?.language
                ? FetchLanguagesData?.data?.data?.find(
                    (lang) => lang?.languagename === personalForm?.language,
                  )?.languagename
                : FetchLanguagesData?.data?.data?.[0]?.languagename
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export function SelectNav({
  items,
  children,
  selectedItem,
  setSelectedItem,
  personalForm,
  errors,
  setErrors,
  screen = "Info",
}) {
  return (
    <div className={styles.selectedNavContainer}>
      <div className={styles.navItemsList}>
        {items.length > 0 &&
          items.map((item, index) => {
            return (
              <div
                key={index}
                onClick={() => {
                  if (screen === "Info") {
                    const obj = {
                      firstName: false,
                      email: false,
                      password: false,
                      initials: false,
                    };
                    if (!personalForm?.firstname) obj.firstName = true;
                    if (!personalForm?.email) obj.email = true;
                    if (!personalForm?.initials) obj.initials = true;
                    // if (!personalForm?.password) obj.password = true;
                    if (Object.keys(obj).some((item) => obj[item] === true))
                      return setErrors(obj);
                    else {
                      setSelectedItem(item);
                    }
                  } else {
                    setSelectedItem(item);
                  }
                }}
                className={styles.singleNavItem}
                style={{
                  backgroundColor:
                    item === selectedItem ? "#e4edfa" : "inherit",
                  color: item === selectedItem ? "black" : "#858585",
                }}
              >
                {item}
              </div>
            );
          })}
      </div>
      {children}
    </div>
  );
}

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  width: "100%",
  "& .MuiInputBase-root": {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.grey[300],
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.grey[300],
  },
}));

export const LegalInformationForm = ({ legalForm, setLegalForm }) => {
  const dispatch = useDispatch();
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedFunction, setSelectedFunction] = useState("");
  const [selectedContract, setSelectedContract] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const {
    idsType,
    employeeType,
    contractType,
    companyCar,
    fetchedReasons,
    FetchJobtypes,
  } = useSelector((state) => state.user);

  const handleChange = (name, event) => {
    const value = event.target.value;
    setLegalForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  console.log("asc44", legalForm);

  useEffect(() => {
    if (
      Object.keys(legalForm).length > 0 &&
      employeeType &&
      employeeType.length > 0
    ) {
      setSelectedEmployee(
        employeeType.find(
          (employee) => employee.employeeTypeId === legalForm.typeOfEmployeeid,
        )?.employeeTypeName,
      );
    }
  }, [employeeType]);

  useEffect(() => {
    if (legalForm.typeOfEmployeename) {
      setSelectedEmployee(legalForm.typeOfEmployeename);
    }
    if (legalForm.typeofIDname) {
      setSelectedId(legalForm.typeofIDname);
    }
    if (legalForm.functionname) {
      setSelectedFunction(legalForm.functionname);
    }
    if (legalForm.contractTypeName) {
      setSelectedContract(legalForm.contractTypeName);
    }
  }, []);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Co-Workers").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const AddJobtypesRes = useSelector((state) => state.user.AddJobtypes);

  const AddTypeOfEmployeeRes = useSelector(
    (state) => state.user.AddTypeOfEmployeeRes,
  );

  const AddTypeOfIDRes = useSelector((state) => state.user.AddTypeOfIDRes);

  const AddContractTypeRes = useSelector(
    (state) => state.user.AddContractTypeRes,
  );

  useEffect(() => {
    if (AddJobtypesRes.status === true) {
      setLegalForm((prev) => ({
        ...prev,
        functionid: AddJobtypesRes?.data?.jobtypeid,
      }));
    }
  }, [AddJobtypesRes]);

  useEffect(() => {
    if (AddTypeOfEmployeeRes.status === true) {
      setLegalForm((prev) => ({
        ...prev,
        typeOfEmployeeid: AddTypeOfEmployeeRes?.data?.employeeTypeId,
      }));
    }
  }, [AddTypeOfEmployeeRes]);

  useEffect(() => {
    if (AddTypeOfIDRes.status === true) {
      setLegalForm((prev) => ({
        ...prev,
        typeofIDid: AddTypeOfIDRes?.data?.idsTypeid,
      }));
    }
  }, [AddTypeOfIDRes]);

  useEffect(() => {
    if (AddContractTypeRes.status === true) {
      setLegalForm((prev) => ({
        ...prev,
        contracttypeid: AddContractTypeRes?.data?.contractTypeId,
      }));
    }
  }, [AddContractTypeRes]);

  return (
    <Box sx={{ margin: "auto", paddingY: 2, marginTop: 1 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={6}>
          <CustomDropDown
            // label="Type of Employee"
            label={t("Type of Employee")}
            onSelect={(option) =>
              handleChange("typeOfEmployeeid", { target: { value: option } })
            }
            options={
              employeeType &&
              employeeType.length > 0 &&
              employeeType.map((employee) => {
                return {
                  label: employee.employeeTypeName,
                  value: employee.employeeTypeId,
                };
              })
            }
            selectedOption={selectedEmployee}
            setSelectedOption={setSelectedEmployee}
            deleteOption={(id) => {
              dispatch(deleteEmployeeType(id));
            }}
            editOption={(option) => {
              dispatch(
                updateAndDeleteEmployeeType({
                  employeeTypeId: option.value,
                  employeeTypeName: option.label,
                }),
              );
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <CustomDropDown
            // label="Function"
            label={t("Function")}
            onSelect={(option) =>
              handleChange("functionid", { target: { value: option } })
            }
            options={
              FetchJobtypes?.data?.data &&
              FetchJobtypes?.data?.data.length > 0 &&
              FetchJobtypes?.data?.data.map((employee) => {
                return {
                  label: employee.jobtypename,
                  value: employee.jobtypeid,
                };
              })
            }
            selectedOption={selectedFunction}
            setSelectedOption={setSelectedFunction}
            deleteOption={(id) => {
              dispatch(DeleteJobtypes(id));
            }}
            editOption={(option) => {
              if (option.value === null) {
                dispatch(AddJobtypes(userid, option.label));
              } else {
                dispatch(UpdateJobtypes(option.value, option.label));
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <CustomDropDown
            // label="Type of ID"
            label={t("Type of ID")}
            onSelect={(option) =>
              handleChange("typeofIDid", { target: { value: option } })
            }
            options={
              idsType &&
              idsType.length > 0 &&
              idsType.map((employee) => {
                return {
                  label: employee.idsTypeName,
                  value: employee.idsTypeid,
                };
              })
            }
            selectedOption={selectedId}
            setSelectedOption={setSelectedId}
            deleteOption={(id) => {
              dispatch(deleteIdsType(id));
            }}
            editOption={(option) => {
              dispatch(
                updateAndDeleteIdsType({
                  idsTypeid: option.value,
                  idsTypeName: option.label,
                }),
              );
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <CustomDropDown
            // label="Contract type"
            label={t("Contract Type")}
            onSelect={(option) =>
              handleChange("contracttypeid", { target: { value: option } })
            }
            options={
              contractType &&
              contractType.length > 0 &&
              contractType.map((employee) => {
                return {
                  label: employee.contractTypeName,
                  value: employee.contractTypeId,
                };
              })
            }
            selectedOption={selectedContract}
            setSelectedOption={setSelectedContract}
            deleteOption={(id) => {
              dispatch(deleteContractType(id));
            }}
            editOption={(option) => {
              dispatch(
                updateAndDeleteContractType({
                  contractTypeId: option.value,
                  contractTypeName: option.label,
                }),
              );
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <CustomDate
            // label="Trial Period End"
            label={t("Trial Period End")}
            value={legalForm.trialPeriodend}
            onChange={(e) =>
              handleChange("trialPeriodend", { target: { value: e } })
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <StyledTextField
            // label="ID Number"
            label={t("ID Number")}
            value={legalForm.idNumber}
            onChange={(e) => handleChange("idNumber", e)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <CustomDate
            // label="Validity"
            label={t("Validity")}
            value={legalForm.validity}
            onChange={(e) => handleChange("validity", { target: { value: e } })}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={3}>
          <CustomDate
            // label="Contract Start Date"
            label={t("Contract Start Date")}
            type="date"
            value={legalForm.contractStartDate}
            onChange={(e) =>
              handleChange("contractStartDate", { target: { value: e } })
            }
          />
        </Grid>

        <Grid item xs={12} sm={12} md={3}>
          <CustomDate
            // label="Contract end date"
            label={t("Contract End Date")}
            value={legalForm.contactEndDate}
            onChange={(e) =>
              handleChange("contactEndDate", { target: { value: e } })
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <StyledTextField
            label={t("Security number")}
            // label="Security Number"
            placeholder="000.000.000"
            value={legalForm.securityNumber}
            onChange={(e) => handleChange("securityNumber", e)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <FormControl
            component="fieldset"
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "10px",
              padding: "0 10px",
              width: "100%",
              "&:focus": { borderColor: "#123a8b" },
            }}
          >
            <InputLabel>
              {/* Tax Discount */}
              {t("Tax Discount")}
            </InputLabel>
            <RadioGroup
              row
              name="taxDiscount"
              value={legalForm.taxdiscount}
              onChange={(e) => handleChange("taxdiscount", e)}
            >
              <FormControlLabel
                value="1"
                control={<Radio />}
                // label="Yes"
                label={t("Yes")}
              />
              <FormControlLabel
                value="0"
                control={<Radio />}
                // label="No"
                label={t("No")}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <FormControl
            component="fieldset"
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "10px",
              padding: "0 10px",
              width: "100%",
              "&:focus": { borderColor: "#123a8b" },
            }}
          >
            <InputLabel>
              {/* Written Contract */}
              {t("Written Contract")}
            </InputLabel>
            <RadioGroup
              row
              name="writtenContract"
              value={legalForm.writtenContract}
              onChange={(e) => handleChange("writtenContract", e)}
            >
              <FormControlLabel
                value="1"
                control={<Radio />}
                // label="Yes"
                label={t("Yes")}
              />
              <FormControlLabel
                value="0"
                control={<Radio />}
                // label="No"
                label={t("No")}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <CustomTextField
            // label="Vacations day per year"
            label={t("Vacations day per year")}
            InputLabelProps={{ shrink: true }}
            value={legalForm.vacationsdayperyear}
            onChange={(e) => handleChange("vacationsdayperyear", e)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <StyledTextField
            // label="Notes"
            label={t("Notes")}
            fullWidth
            value={legalForm.notes}
            onChange={(e) => handleChange("notes", e)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <CustomDate
            // label="Pension expected date"
            label={t("Pension Expected Date")}
            value={legalForm.pensionExpectedDate}
            onChange={(e) =>
              handleChange("pensionExpectedDate", { target: { value: e } })
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <StyledTextField
            // label="Cost Center"
            label={t("Cost Center")}
            value={legalForm.costCenter}
            onChange={(e) => handleChange("costCenter", e)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export const BankAccountForm = ({ bankAccounts, setBankAccounts }) => {
  const AddButton = styled(Button)(({ theme }) => ({
    color: theme.palette.text.secondary,
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "transparent",
    },
  }));

  const handleChange = (index, field, value) => {
    const updatedAccounts = [...bankAccounts];
    updatedAccounts[index][field] = value;
    setBankAccounts(updatedAccounts);
  };

  const addBankAccount = () => {
    setBankAccounts([
      ...bankAccounts,
      {
        bankaccountIBAN: "",
        default: 0,
        description: "",
        bankAccountHolder: "",
      },
    ]);
  };

  const removeBankAccount = (index) => {
    const updatedAccounts = bankAccounts.filter((_, i) => i !== index);
    setBankAccounts(updatedAccounts);
  };
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Co-Workers").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  return (
    <Box sx={{ width: "100%", paddingY: 2, marginTop: 1 }}>
      <AddButton
        startIcon={<AddIcon sx={{ fontSize: 20 }} />}
        onClick={addBankAccount}
      >
        {/* Add Bank Account */}
        {t("Add Bank Account")}
      </AddButton>
      {bankAccounts.map((account, index) => (
        <Grid container spacing={2} key={index} sx={{ mt: 2 }}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              variant="outlined"
              // label="Bankaccount IBAN"
              label={t("Bank Account IBAN")}
              InputLabelProps={{ shrink: true }}
              value={account?.bankaccountIBAN}
              onChange={(e) =>
                handleChange(index, "bankaccountIBAN", e.target.value)
              }
              placeholder="DE89 3704 0044 0532 0130 00"
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    sx={{
                      position: "absolute",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      top: "0",
                      right: 20,
                      zIndex: 100,
                    }}
                  >
                    <input
                      type="checkbox"
                      // checked={item.checked}
                      className="form-check-input pointer companyRadio ms-"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        zIndex: 100,
                      }}
                      checked={account.default}
                      onChange={(e) =>
                        handleChange(
                          index,
                          "default",
                          account.default === 0 ? 1 : 0,
                        )
                      }
                    />
                    <Typography
                      variant="caption1"
                      color="textSecondary"
                      className="bg-white"
                    >
                      {/* Default */}
                      {t("Default")}
                    </Typography>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              variant="outlined"
              // label="Description"
              label={t("Description")}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                handleChange(index, "description", e.target.value)
              }
              // placeholder="Enter description"
              placeholder={t("Enter Description")}
              value={account?.description}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              variant="outlined"
              // label="Bank Account Holder"
              label={t("Bank Account Holder")}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                handleChange(index, "bankAccountHolder", e.target.value)
              }
              // placeholder="Full name"
              placeholder={t("Full Name")}
              value={account?.bankAccountHolder}
            />
          </Grid>
          <Grid item xs={12} md={1}>
            <IconButton
              size="small"
              sx={{ color: "text.secondary" }}
              onClick={() => removeBankAccount(index)}
            >
              <DeleteOutlineIcon />
            </IconButton>
          </Grid>
        </Grid>
      ))}
    </Box>
  );
};

export const CompanyCarForm = ({ transportForm, setTransportForm }) => {
  const dispatch = useDispatch();
  const AddBenifitCompanyCarRes = useSelector(
    (state) => state.user.AddBenifitCompanyCarRes,
  );

  const AddBenifitReasonsRes = useSelector(
    (state) => state.user.AddBenifitReasonsRes,
  );

  const [selectedCompanyCar, setSelectedCompanyCar] = useState("");
  const [selectedReason, setSelectedReason] = useState("");

  const { companyCar, fetchedReasons } = useSelector((state) => state.user);
  const handleChange = (name, event) => {
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    setTransportForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Co-Workers").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  useEffect(() => {
    if (transportForm.companyCarname) {
      setSelectedCompanyCar(transportForm.companyCarname);
    }
    if (transportForm.reasonname) {
      setSelectedReason(transportForm.reasonname);
    }
  }, []);

  useEffect(() => {
    if (AddBenifitCompanyCarRes.status === true) {
      setTransportForm((prev) => ({
        ...prev,
        companyCarid: AddBenifitCompanyCarRes?.data?.companyCarId,
      }));
    }
  }, [AddBenifitCompanyCarRes]);

  useEffect(() => {
    if (AddBenifitReasonsRes.status === true) {
      setTransportForm((prev) => ({
        ...prev,
        reasonid: AddBenifitReasonsRes?.data?.reasonid,
      }));
    }
  }, [AddBenifitReasonsRes]);

  return (
    <Box sx={{ margin: "auto", paddingY: 2, marginTop: 1 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <CustomDropDown
            // label="Company Car"
            label={t("Company Car")}
            onSelect={(option) =>
              handleChange("companyCarid", { target: { value: option } })
            }
            options={
              companyCar &&
              companyCar.length > 0 &&
              companyCar.map((employee) => {
                return {
                  label: employee.companyCarName,
                  value: employee.companyCarId,
                };
              })
            }
            selectedOption={selectedCompanyCar}
            setSelectedOption={setSelectedCompanyCar}
            deleteOption={(id) => {
              dispatch(deleteCompanyCar(id));
            }}
            editOption={(option) => {
              dispatch(
                updateAndDeleteCompanyCar({
                  companyCarId: option.value,
                  companyCarName: option.label,
                }),
              );
            }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <CustomDate
            // label="Leasing Start Date"
            label={t("Leasing Start Date")}
            value={transportForm.leasingStartDate}
            onChange={(e) =>
              handleChange("leasingStartDate", { target: { value: e } })
            }
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            variant="outlined"
            // label="Car value"
            label={t("Car value")}
            // InputLabelProps={{ shrink: true }}
            value={transportForm.carvalue}
            onChange={(e) => handleChange("carvalue", e)}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            variant="outlined"
            // label="Addition Tax"
            label={t("Addition Tax")}
            // InputLabelProps={{ shrink: true }}
            value={transportForm.additionalTax}
            onChange={(e) => handleChange("additionalTax", e)}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <CustomDropDown
            // label="Reason"
            label={t("Reason")}
            onSelect={(option) =>
              handleChange("reasonid", { target: { value: option } })
            }
            options={
              fetchedReasons &&
              fetchedReasons.length > 0 &&
              fetchedReasons.map((employee) => {
                return {
                  label: employee.reasonname,
                  value: employee.reasonid,
                };
              })
            }
            selectedOption={selectedReason}
            setSelectedOption={setSelectedReason}
            deleteOption={(id) => {
              dispatch(deleteReasons(id));
            }}
            editOption={(option) => {
              dispatch(
                updateAndDeleteReasons({
                  reasonid: option.value,
                  reasonname: option.label,
                }),
              );
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl
            component="fieldset"
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "10px",
              padding: "0 10px",
              width: "100%",
              "&:focus": { borderColor: "#123a8b" },
            }}
          >
            <InputLabel>
              {/* Driver agreement/car regulations */}
              {t("Driver agreement/car regulations")}
            </InputLabel>

            <RadioGroup
              row
              name="driveagreementcarregulations"
              value={transportForm.driveagreementcarregulations}
              onChange={(e) => handleChange("driveagreementcarregulations", e)}
              sx={{ display: "flex", alignItems: "flex-start", gap: "30px" }}
            >
              <FormControlLabel
                value="1"
                control={<Radio />}
                // label="Yes"
                label={t("Yes")}
                sx={{ width: "3rem" }}
              />
              <FormControlLabel
                value="0"
                control={<Radio />}
                // label="No"
                label={t("No")}
                sx={{ width: "3rem" }}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl
            component="fieldset"
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "10px",
              padding: "0 10px",
              width: "100%",
              "&:focus": { borderColor: "#123a8b" },
            }}
          >
            <InputLabel>
              {/* Public Transport */}
              {t("Public Transport")}
            </InputLabel>
            <RadioGroup
              row
              name="publicTransport"
              value={transportForm.publicTransport}
              onChange={(e) => handleChange("publicTransport", e)}
              sx={{ display: "flex", alignItems: "flex-start", gap: "30px" }}
            >
              <FormControlLabel
                value="1"
                control={<Radio />}
                // label="Yes"
                label={t("Yes")}
                sx={{ width: "3rem" }}
              />
              <FormControlLabel
                value="0"
                control={<Radio />}
                // label="No"
                label={t("No")}
                sx={{ width: "3rem" }}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl
            component="fieldset"
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "10px",
              padding: "0 10px",
              width: "100%",
              "&:focus": { borderColor: "#123a8b" },
            }}
          >
            <InputLabel>
              {/* Transport expenses Reimbursement */}
              {t("Transport expenses Reimbursement")}
            </InputLabel>

            <RadioGroup
              row
              name="transportexpensesReimbursement"
              value={transportForm.transportexpensesReimbursement}
              onChange={(e) =>
                handleChange("transportexpensesReimbursement", e)
              }
              sx={{ display: "flex", alignItems: "flex-start", gap: "30px" }}
            >
              <FormControlLabel
                value="1"
                control={<Radio />}
                // label="Yes"
                label={t("Yes")}
                sx={{ width: "3rem" }}
              />
              <FormControlLabel
                value="0"
                control={<Radio />}
                // label="No"
                label={t("No")}
                sx={{ width: "3rem" }}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  boxShadow: "none",
  border: `1px solid ${theme.palette.divider}`,
}));

const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  "&:hover": {
    backgroundColor: "transparent",
  },
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: theme.shape.borderRadius,
  padding: 4,
  "&:hover": {
    backgroundColor: theme.palette.background.paper,
  },
}));

const StyledSwitch = styled(Switch)(({ theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    "&:before, &:after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
  },
}));

export function WageScreen() {
  const [wageRate, setWageRate] = useState(2500);
  const [billRate, setBillRate] = useState(5000);
  const [paymentPeriod, setPaymentPeriod] = useState("Monthly");
  const [workingHours, setWorkingHours] = useState({
    Mon: 8,
    Tue: 8,
    Wed: 8,
    Thu: 8,
    Fri: 8,
    Sat: 0,
    Sun: 0,
  });
  const [authRole, setAuthRole] = useState("Manager");
  const [isActive, setIsActive] = useState(true);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Co-Workers").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  }));

  const WeekdayBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1),
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,
  }));

  const WeekendBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1),
    border: `1px dashed ${theme.palette.grey[400]}`,
    borderRadius: theme.shape.borderRadius,
  }));

  return (
    <Box sx={{ maxWidth: 800, margin: "auto", padding: 2 }}>
      <StyledPaper>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              // label="Wage Rate"
              label={t("Wage rate")}
              value={wageRate}
              onChange={(e) => setWageRate(e.target.value)}
              fullWidth
              InputProps={{ startAdornment: "€" }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              // label="Bill Rate"
              label={t("Bill Rate ")}
              value={billRate}
              onChange={(e) => setBillRate(e.target.value)}
              fullWidth
              InputProps={{ startAdornment: "€" }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Select
              value={paymentPeriod}
              onChange={(e) => setPaymentPeriod(e.target.value)}
              fullWidth
            >
              <MenuItem value="Monthly">
                {/* Monthly */}
                {t("Monthly")}
              </MenuItem>
              <MenuItem value="Weekly">
                {/* Weekly */}
                {t("Weekly")}
              </MenuItem>
            </Select>
          </Grid>
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <Typography>Type: Fixed</Typography>
          <FormControlLabel control={<Checkbox />} label="Payroll" />
          <FormControlLabel control={<Checkbox />} label="Timesheet approval" />
        </Box>
      </StyledPaper>

      <StyledPaper>
        <Typography variant="h6" gutterBottom>
          Working Time
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography>Total Even week44: 40</Typography>
          <Typography>Total Odd week: 40</Typography>
          <FormControlLabel control={<Checkbox />} label="Apply to all Year" />
        </Box>
        <Grid container spacing={2}>
          {Object.entries(workingHours).map(([day, hours]) => (
            <Grid item xs={12} sm={6} md={3} key={day}>
              <Typography variant="subtitle2">{day}</Typography>
              {["Mon", "Tue", "Wed", "Thu", "Fri"].includes(day) ? (
                <WeekdayBox>
                  <TextField
                    value={hours}
                    onChange={(e) =>
                      setWorkingHours({
                        ...workingHours,
                        [day]: e.target.value,
                      })
                    }
                    fullWidth
                  />
                </WeekdayBox>
              ) : (
                <WeekendBox>
                  <TextField
                    value={hours}
                    onChange={(e) =>
                      setWorkingHours({
                        ...workingHours,
                        [day]: e.target.value,
                      })
                    }
                    fullWidth
                  />
                </WeekendBox>
              )}
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={2}>
          {Object.entries(workingHours).map(([day, hours]) => (
            <Grid item xs={12} sm={6} md={3} key={day}>
              <Typography variant="subtitle2">{day}</Typography>
              {["Mon", "Tue", "Wed", "Thu", "Fri"].includes(day) ? (
                <WeekdayBox>
                  <TextField
                    value={hours}
                    onChange={(e) =>
                      setWorkingHours({
                        ...workingHours,
                        [day]: e.target.value,
                      })
                    }
                    fullWidth
                  />
                </WeekdayBox>
              ) : (
                <WeekendBox>
                  <TextField
                    value={hours}
                    onChange={(e) =>
                      setWorkingHours({
                        ...workingHours,
                        [day]: e.target.value,
                      })
                    }
                    fullWidth
                  />
                </WeekendBox>
              )}
            </Grid>
          ))}
        </Grid>
      </StyledPaper>

      <StyledPaper>
        <Typography variant="h6" gutterBottom>
          Authorisation Role
        </Typography>
        <ToggleButtonGroup
          value={authRole}
          exclusive
          onChange={(e, newRole) => setAuthRole(newRole)}
          aria-label="authorisation role"
        >
          <ToggleButton value="Owner">Owner</ToggleButton>
          <ToggleButton value="Manager">Manager</ToggleButton>
          <ToggleButton value="User">User</ToggleButton>
          <ToggleButton value="Viewer">Viewer</ToggleButton>
        </ToggleButtonGroup>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <FormControlLabel
            control={
              <Switch
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
              />
            }
            label="Active?"
          />
        </Box>
      </StyledPaper>
    </Box>
  );
}

const StyledPopover = styled(Popover)(({ theme }) => ({
  "& .MuiPopover-paper": {
    padding: theme.spacing(3),
    width: 600,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#fafafa",
  },
}));

const FormField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  "& .MuiOutlinedInput-root": {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    "& fieldset": {
      borderColor: theme.palette.divider,
    },
  },
}));

// CERTIFICATION

export function CustomDropdown({
  certificationList,
  addCertification,
  onClose,
  setTotalCertifications,
}) {
  const dispatch = useDispatch();
  const coWorkerCertificationsApiRes = useSelector(
    (state) => state.user.coWorkerCertificationsApiRes,
  );
  const [certificationName, setCertificationName] = useState("");
  const [certificationID, setCertificationID] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [expiringDate, setExpiringDate] = useState("");
  const [notifyDayBefore, setNotifyDayBefore] = useState("");
  const [notify, setNotify] = useState(false);
  const [hasError, setHasError] = useState("");

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Co-Workers").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const errors = {
    certificationName: "Please select Certification",
    idNumber: "Please enter ID Number",
    expiringDate: "Please enter Expiring Date",
  };

  const addCerti = () => {
    const obj = {
      certificationName: certificationName,
      idNumber: idNumber,
      expiringDate: expiringDate,
      notifydaybefore: notifyDayBefore,
      docid: "",
    };
    if (!certificationName) return setHasError("certification");
    if (!expiringDate) return setHasError("expiry");
    if (!idNumber) return setHasError("id");
    setTotalCertifications((prev) => [...prev, obj]);
    onClose();
  };

  useEffect(() => {
    if (coWorkerCertificationsApiRes.status === true) {
      setCertificationName(
        coWorkerCertificationsApiRes?.data?.certificationName,
      );
      setCertificationID(coWorkerCertificationsApiRes?.data?.certificationId);
    }
  }, [coWorkerCertificationsApiRes]);

  useEffect(() => {
    dispatch(fetchUserCertification());
  }, [coWorkerCertificationsApiRes]);

  return (
    <div style={{}}>
      <StyledPopover
        open={addCertification}
        placement="bottom-start"
        sx={{ width: "100%" }}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
      >
        <CloseIcon
          sx={{
            position: "absolute",
            top: 5,
            right: 5,
            height: 14,
            width: 14,
            border: "1px solid #9e9e9e",
            borderRadius: "50%",
            cursor: "pointer",
          }}
          onClick={onClose}
        />
        {/* <CustomSelect
          // label="Certification Name"
          label={FetchTranslationList[183]?.translation}
          options={
            certificationList &&
            certificationList.map((title) => {
              return {
                label: title?.certificationName,
                value: title?.certificationName,
              };
            })
          }
          value={certificationName}
          onChange={(e) => {
            setCertificationName(e.target.value);
            setHasError("");
          }}
        /> */}

        {/* asc certification start */}
        <CustomDropDown
          label={t("Certification Name")}
          selectedOption={certificationName}
          setSelectedOption={setCertificationName}
          onSelect={(option) => {
            setCertificationID(option);
            setHasError("");
          }}
          options={
            certificationList &&
            certificationList.map((item) => {
              return {
                label: item?.certificationName,
                value: item?.certificationId,
              };
            })
          }
          deleteOption={(id) => {
            dispatch(
              coWorkerCertification({
                certificationName: null,
                certificationId: id,
              }),
            );
            setCertificationName("");
            setCertificationID("");
          }}
          editOption={(option) => {
            dispatch(
              coWorkerCertification({
                certificationId: option.value,
                certificationName: option.label,
              }),
            );
          }}
        />
        {/* asc certification end */}
        {hasError === "certi" && (
          <Typography
            variant="caption1"
            color={"red"}
            sx={{ marginTop: "10px" }}
          >
            {errors.certificationName}
          </Typography>
        )}
        <Grid container spacing={1} sx={{ marginTop: "10px" }}>
          <Grid item xs={12} sm={4}>
            <CustomDate
              // label="Expiring Date"
              label={t("Expiring Date")}
              value={expiringDate}
              onChange={(e) => {
                setExpiringDate(e);
                setHasError("");
              }}
            />
            {hasError === "expiry" && (
              <Typography variant="caption1" color={"red"}>
                {errors.expiringDate}
              </Typography>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography variant="caption1" color={"#00246a"}>
              {/* Notify */}
              {t("Notify")}
            </Typography>
            <StyledSwitch
              className="profiletoggle"
              // value={item?.returnatContracttermination}
              onChange={(e) => setNotify((prev) => !prev)}
              checked={notify}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <CustomTextField
              disabled={!notify}
              // label="Days Before"
              label={t("Days Before")}
              onChange={(e) => setNotifyDayBefore(e.target.value)}
              value={notifyDayBefore}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <CustomTextField
              // label="ID Number"
              label={t("ID Number")}
              value={idNumber}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setIdNumber(e.target.value);
                setHasError("");
              }}
            />
            {hasError === "id" && (
              <Typography variant="caption1" color={"red"}>
                {errors.idNumber}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "1rem",
          }}
        >
          <Button sx={{ padding: "5px 30px" }} onClick={addCerti}>
            {/* Add */}
            {t("Add")}
          </Button>
        </Box>
        {/* <CloseIcon
          onClick={onClose}
          sx={{ position: "absolute", top: 4, right: 4 }}
        /> */}
      </StyledPopover>
    </div>
  );
}
const CertificationCard = ({
  certificationName,
  idNumber,
  expiringDate,
  notifydaybefore,
  docid,
  insertedDoc,
  index,
  setTotalCertifications,
  totalCertifications,
  onClickDoc,
}) => {
  const dispatch = useDispatch();
  const uploadRef = useRef();
  const [loading, setLoading] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Co-Workers").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const UploadFile = async () => {
    const file = uploadRef.current.files[0];
    const formData = new FormData();
    formData.append("file", file);
    try {
      setLoading(true);
      const response = await axios.post(
        `${API_URL}/api/Files/InsertDocToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      let docid;
      let link;
      if (response?.status === 200) {
        docid = response?.data?.[0]?.data?.documentid;
        link = response?.data?.[0]?.data?.link;
      }
      setTotalCertifications((prev) => {
        const existing = [...prev];
        existing[index]["docid"] = docid;
        existing[index]["link"] = link;
        return existing;
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <StyledPaper sx={{ position: "relative" }}>
      <Typography
        variant="subtitle1"
        style={{
          marginBottom: 2,
          fontWeight: "medium",
          transformOrigin: "top left",
          whiteSpace: " nowrap",
          overFlow: "hidden",
          textOverflow: "ellipsis ",
          // maxWidth: " calc(133%-32px) ",
          position: " absolute ",
          top: 0,
          left: " 0 ",
          transform: "translate(14px, -9px) scale(0.75) ",
          transition:
            "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
          zIndex: 1,
          pointerEvents: "auto",
          backgroundColor: "white",
          padding: "0 10px",
          margin: 0,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "10px",
        }}
        onMouseEnter={() => setShowDelete(true)}
        onMouseLeave={() => setShowDelete(false)}
      >
        {certificationName}
        {showDelete && (
          <img
            style={{ cursor: "pointer", height: 14, width: 14 }}
            size={24}
            src={del}
            alt=""
            onClick={() =>
              setTotalCertifications(
                totalCertifications.filter((time, i) => i !== index),
              )
            }
          />
        )}
      </Typography>
      <Box
        size="small"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 2,
          fontWeight: "medium",
          transformOrigin: "top left",
          whiteSpace: " nowrap",
          overFlow: "hidden",
          textOverflow: "ellipsis ",
          // maxWidth: " calc(133%-32px) ",
          position: " absolute ",
          top: 0,
          right: 0,
          transform: "translate(14px, -9px) scale(0.75) ",
          transition:
            "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
          zIndex: 1,
          pointerEvents: "auto",
          backgroundColor: "white",
          padding: "0 10px",
          marginRight: "10px",
        }}
      >
        <input
          type="file"
          ref={uploadRef}
          className="d-none"
          onChange={UploadFile}
          // accept={filefilter}
        />
        {loading ? (
          <LoadingOutlined />
        ) : totalCertifications[index]["docid"] ? (
          <CheckCircleOutlined
            style={{
              backgroundColor: "#00246a",
              borderRadius: "50%",
              color: "white",
              cursor: "pointer",
            }}
            onClick={() => uploadRef.current.click()}
          />
        ) : (
          <AddIcon
            fontSize="small"
            sx={{
              backgroundColor: "#00246a",
              borderRadius: "50%",
              color: "white",
              cursor: "pointer",
            }}
            onClick={() => uploadRef.current.click()}
          />
        )}
        <Typography variant="caption" sx={{ ml: 0.5 }}>
          {/* Doc */}
          {t("Doc")}
        </Typography>
      </Box>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={3}>
          <Typography
            variant="caption1"
            color="textSecondary"
            sx={{
              margin: 0,
              height: "12px",
              display: "block",
              marginBottom: "15px",
            }}
          >
            {/* ID number */}
            {t("ID Number")}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {idNumber}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <Typography
            variant="caption1"
            color="textSecondary"
            sx={{
              margin: 0,
              height: "12px",
              display: "block",
              marginBottom: "15px",
            }}
          >
            {/* Expiring Date */}
            {t("Expiring Date")}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <CalendarTodayIcon sx={{ fontSize: 18, mr: 1 }} />
            <Typography variant="caption" color="textSecondary">
              {expiringDate ? moment(expiringDate).format("DD-MM-YYYY") : ""}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Typography
            variant="caption1"
            color="textSecondary"
            sx={{
              margin: 0,
              height: "12px",
              display: "block",
              marginBottom: "15px",
              width: "fit-content",
            }}
          >
            {/* Notify day(s) before */}
            {t(" Notify day(s) before")}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {notifydaybefore}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2}>
          <Typography
            variant="caption1"
            color="textSecondary"
            sx={{
              margin: 0,
              height: "12px",
              display: "block",
              marginBottom: "15px",
            }}
          >
            {/* Doc */}
            {t("Doc")}
          </Typography>
          <IconButton size="small">
            <PictureAsPdfIcon
              sx={{
                color: totalCertifications[index]["docid"] ? "#00246a" : "red",
              }}
              onClick={onClickDoc}
            />
          </IconButton>
        </Grid>
      </Grid>
    </StyledPaper>
  );
};

export const CertificationList = ({
  certificationList,
  insertedDoc,
  totalCertifications,
  setTotalCertifications,
}) => {
  const [addCertification, setAddCertification] = useState(false);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Co-Workers").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const onClose = () => {
    setAddCertification(false);
  };

  return (
    <Box sx={{ width: "100%", margin: "auto", paddingY: 2, marginTop: 1 }}>
      <StyledButton
        startIcon={<AddIcon />}
        sx={{ mb: 2 }}
        onClick={() => setAddCertification(true)}
      >
        {/* Add New Certification */}
        {t("Add New Certification")}
      </StyledButton>
      {addCertification && (
        <CustomDropdown
          certificationList={certificationList}
          addCertification={addCertification}
          onClose={onClose}
          setTotalCertifications={setTotalCertifications}
        />
      )}
      <Grid container spacing={2}>
        {totalCertifications &&
          totalCertifications.length > 0 &&
          totalCertifications.map((cert, index) => (
            <Grid item xs={12} md={6} key={index}>
              <CertificationCard
                {...cert}
                insertedDoc={insertedDoc}
                index={index}
                setTotalCertifications={setTotalCertifications}
                totalCertifications={totalCertifications}
                onClickDoc={() => {
                  if (cert["link"]) {
                    window.open(cert["link"], "_blank");
                  }
                }}
              />
            </Grid>
          ))}
      </Grid>
    </Box>
  );
};

// PROVIDED ITEMS
export const ProvidedItems = ({ providedItems, setProvidedItems }) => {
  const [addNewItem, setAddNewItem] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [allStatus, setAllStatus] = useState(["Issued", "Returned"]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDelete, setShowDelete] = useState([]);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Co-Workers").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    boxShadow: "none",
    border: `1px solid ${theme.palette.divider}`,
  }));

  useEffect(() => {
    if (providedItems.length > 0)
      setShowDelete(new Array(providedItems.length).fill(false));
  }, [providedItems]);

  return (
    <>
      <Box
        sx={{
          margin: "auto",
          paddingY: 2,
          marginTop: 1,
          width: "100%",
          position: "relative",
        }}
      >
        <Box
          sx={{
            mb: 1,
            cursor: "pointer",
            position: "absolute",
            width: "fit-content",
            top: 0,
          }}
          onClick={() => {
            setSelectedItem("");
            setAddNewItem(true);
          }}
        >
          <AddIcon />
          <Typography variant="caption">
            {/* Add New */}
            {t("Add New")}
          </Typography>
        </Box>
        <AddNewItemPopover
          open={addNewItem}
          onClose={() => setAddNewItem(false)}
          setProvidedItems={setProvidedItems}
          allStatus={allStatus}
          selectedItem={selectedItem}
          selectedIndex={selectedIndex}
          setSelectedItem={setSelectedItem}
        />
        {providedItems.length > 0 && (
          <>
            {providedItems.length > 0 &&
              providedItems.map((item, index) => {
                return (
                  <StyledPaper sx={{ position: "relative", marginTop: 5 }}>
                    <Box
                      sx={{
                        position: "absolute",
                        top: "-10px",
                        left: 10,
                        padding: "0 10px",
                        backgroundColor: "white",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "10px",
                      }}
                      onMouseEnter={() =>
                        setShowDelete(
                          showDelete.map((del, i) => {
                            return i === index ? true : false;
                          }),
                        )
                      }
                      onMouseLeave={() =>
                        setShowDelete(showDelete.map((del, i) => false))
                      }
                    >
                      <Typography variant="subtitle2">
                        {item?.itemName}
                      </Typography>
                      {showDelete?.[index] && (
                        <img
                          style={{ cursor: "pointer", height: 14, width: 14 }}
                          size={24}
                          src={del}
                          alt=""
                          onClick={() =>
                            setProvidedItems(
                              providedItems.filter((time, i) => i !== index),
                            )
                          }
                        />
                      )}
                    </Box>
                    <Box
                      key={index}
                      position={"relative"}
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "30px",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <Box>
                        <Typography variant="body2" color="textSecondary">
                          {/* Description */}
                          {t("Description")}
                        </Typography>
                        <Typography variant="subtitle2">
                          {item?.itemDescription}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography variant="body2" color="textSecondary">
                          {/* Date Provided */}
                          {t("Date Provided")}
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <CalendarTodayIcon sx={{ fontSize: 18, mr: 1 }} />
                          <Typography variant="subtitle2">
                            {item?.dateProvided
                              ? moment(item?.dateProvided).format("DD-MM-YYYY")
                              : ""}
                          </Typography>
                        </Box>
                      </Box>
                      <Box position={"relative"}>
                        <Typography variant="body2" color="textSecondary">
                          {/* Status */}
                          {t("Status")}
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          {/* <IconButton size="small"> */}

                          {/* </IconButton> */}
                          <Typography variant="subtitle2">
                            {" "}
                            {item?.status}
                          </Typography>
                          <CloseIcon
                            onClick={() => {
                              setOpenStatus(true);
                              setSelectedIndex(index);
                            }}
                            sx={{
                              height: "1rem",
                              width: "1rem",
                              cursor: "pointer",
                            }}
                          />
                        </Box>
                        <StatusPopOver
                          openStatus={openStatus}
                          onClose={() => setOpenStatus(false)}
                          allStatus={allStatus}
                          setAllStatus={setAllStatus}
                          selectedIndex={selectedIndex}
                          setProvidedItems={setProvidedItems}
                        />
                      </Box>
                      <Box>
                        <Typography variant="body2" color="textSecondary">
                          {/* Date of intake */}
                          {t("Date of intake")}
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <CalendarTodayIcon
                            sx={{
                              fontSize: 18,
                              mr: 1,
                              color: "text.secondary",
                            }}
                          />
                          <Typography variant="subtitle2">
                            {" "}
                            {item?.dateofIntake}
                          </Typography>
                        </Box>
                      </Box>
                      <MoreHoriz
                        sx={{
                          position: "absolute",
                          right: 0,
                          bottom: "10%",
                          height: "1rem",
                          width: "1rem",
                          cursor: "pointer",
                          border: "1px solid #a5a5a5",
                          borderRadius: "50%",
                        }}
                        onClick={() => {
                          setAddNewItem(true);
                          setSelectedItem(item);
                          setSelectedIndex(index);
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        mt: 2,
                        gap: 1,
                        position: "absolute",
                        top: "-25px",
                        right: 10,
                        padding: "0 10px",
                        backgroundColor: "white",
                      }}
                    >
                      <Typography variant="body2" color="textSecondary">
                        {/* Return at Contract termination */}
                        {t("Return at Contract termination")}
                      </Typography>
                      <input
                        type="checkbox"
                        checked={item?.returnatContracttermination}
                        className="form-check-input pointer companyRadio ms-"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onChange={(e) =>
                          setProvidedItems((prev) => {
                            const existing = [...prev];
                            existing[index]["returnatContracttermination"] =
                              existing[index]["returnatContracttermination"] ===
                              1
                                ? 0
                                : 1;
                            return existing;
                          })
                        }
                      />
                    </Box>
                  </StyledPaper>
                );
              })}
          </>
        )}
      </Box>
    </>
  );
};
const PopoverContent = memo(
  ({
    setProvidedItems,
    onClose,
    allStatus,
    selectedItem,
    selectedIndex,
    setSelectedItem,
  }) => {
    const [itemName, setItemName] = useState("");
    const [itemDescription, setItemDescription] = useState("");
    const [serialNumber, setSerialNumber] = useState("");
    const [dateProvided, setDateProvided] = useState("");
    const [value, setValue] = useState("");
    const [status, setStatus] = useState("");
    const [returnatContracttermination, setReturnatContracttermination] =
      useState(0);

    const [FetchTranslationList, setFetchTranslationList] = useState({});
    const t = (key) => FetchTranslationList?.[key] || "";
    useEffect(() => {
      fetchScreenTranslations("Add-Co-Workers").then((data) =>
        setFetchTranslationList(data),
      );
    }, []);

    const handleAdd = () => {
      const newEntry = {
        itemName,
        itemDescription,
        dateProvided,
        status,
        returnatContracttermination,
        value,
        serialNumber,
      };

      setProvidedItems((prev) => [...prev, newEntry]);
      onClose();
    };

    const handleUpdate = () => {
      const existingEntry = {
        itemName,
        itemDescription,
        dateProvided,
        status,
        returnatContracttermination,
        value,
        serialNumber,
      };
      setProvidedItems((prev) => {
        const existing = [...prev];
        existing[selectedIndex] = existingEntry;
        return existing;
      });
      setSelectedItem(null);
      onClose();
    };

    useEffect(() => {
      if (selectedItem && Object.keys(selectedItem).length > 0) {
        if (selectedItem.itemName) setItemName(selectedItem.itemName);
        if (selectedItem.itemDescription)
          setItemDescription(selectedItem.itemDescription);
        if (selectedItem.serialNumber)
          setSerialNumber(selectedItem.serialNumber);
        if (selectedItem.dateProvided)
          setDateProvided(selectedItem.dateProvided);
        if (selectedItem.value) setValue(selectedItem.value);
        if (selectedItem.status) setStatus(selectedItem.status);
        if (selectedItem.returnatContracttermination)
          setReturnatContracttermination(
            selectedItem.returnatContracttermination,
          );
      }
    }, [selectedItem]);

    return (
      <Box sx={{ position: "relative", marginBottom: "40px" }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: "-10px",
            top: "-10px",
            // padding: 2,
          }}
        >
          <CloseIcon
            sx={{
              height: "14px",
              width: "14px",
              border: "1px solid #a5a5a5",
              borderRadius: "50%",
            }}
          />
        </IconButton>
        <Typography variant="h6" component="h2" gutterBottom>
          {/* {selectedItem && Object.keys(selectedItem).length > 0
            ? "Details"
            : "Add New Item"} */}
          {selectedItem && Object.keys(selectedItem).length > 0
            ? t("Details")
            : t("Add New Item")}
        </Typography>
        <FormField
          fullWidth
          // label="Item Name"
          label={t("Item Name")}
          variant="outlined"
          // placeholder="Type a name"
          placeholder={t("Type A name ")}
          value={itemName}
          onChange={(e) => setItemName(e.target.value)}
        />
        <FormField
          fullWidth
          // label="Item Description"
          label={t("Item Description")}
          variant="outlined"
          // placeholder="Type a description"
          placeholder={t("Type a description")}
          value={itemDescription}
          onChange={(e) => setItemDescription(e.target.value)}
        />
        <FormField
          fullWidth
          // label="Serial Number"
          label={t("Serial Number")}
          variant="outlined"
          value={serialNumber}
          placeholder={t("Serial Number")}
          onChange={(e) => setSerialNumber(e.target.value)}
        />
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <Box sx={{ mb: 2 }}>
            <CustomDate
              // label="Date Provided"
              label={t("Date Provided")}
              value={dateProvided}
              onChange={(e) => setDateProvided(e)}
            />
          </Box>
          <FormField
            // label="Value"
            label={t("Value")}
            variant="outlined"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            sx={{ flex: 1 }}
          />
        </Box>
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <FormField
            select
            // label="Status"
            label={t("Status")}
            variant="outlined"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            sx={{ flex: 1 }}
          >
            <MenuItem value="">
              {/* Select */}
              {t("Select ")}
            </MenuItem>
            {allStatus.map((status, i) => {
              return (
                <MenuItem value={status} key={i}>
                  {status}
                </MenuItem>
              );
            })}
          </FormField>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              mb: 2,
              alignItems: "center",
              width: "50%",
            }}
          >
            <Typography variant="caption" color="#00246a" sx={{ opacity: 0.6 }}>
              {/* Return at Contract termination */}
              {t("Return at Contract termination")}
            </Typography>
            <input
              type="checkbox"
              checked={returnatContracttermination}
              className="form-check-input pointer companyRadio ms-"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onChange={(e) =>
                setReturnatContracttermination((prev) => (prev === 1 ? 0 : 1))
              }
            />
          </Box>
        </Box>
        <Button
          variant="contained"
          // fullWidth
          onClick={
            selectedItem && Object.keys(selectedItem).length > 0
              ? handleUpdate
              : handleAdd
          }
          sx={{
            mt: 2,
            display: "block",
            margin: "auto",
          }}
        >
          {/* {selectedItem && Object.keys(selectedItem).length > 0
            ? "Change"
            : "Add"} */}
          {selectedItem && Object.keys(selectedItem).length > 0
            ? t("Change")
            : t("Add")}
        </Button>
      </Box>
    );
  },
);

export function AddNewItemPopover({
  open,
  anchorEl,
  onClose,
  setProvidedItems,
  allStatus,
  selectedItem,
  selectedIndex,
  setSelectedItem,
}) {
  const StyledPopover = styled(Popover)(({ theme }) => ({
    "& .MuiPopover-paper": {
      padding: theme.spacing(2),
      width: 400,
      borderRadius: theme.shape.borderRadius,
    },
  }));

  return (
    <StyledPopover
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "center",
        horizontal:
          selectedItem && Object.keys(selectedItem).length > 0
            ? "right"
            : "center",
      }}
      PaperProps={{
        sx: {
          mt: "-80px", // popup thoda aur upar
        },
      }}
    >
      <PopoverContent
        setProvidedItems={setProvidedItems}
        onClose={onClose}
        allStatus={allStatus}
        selectedItem={selectedItem}
        selectedIndex={selectedIndex}
        setSelectedItem={setSelectedItem}
      />
    </StyledPopover>
  );
}

const StatusPopOver = ({
  openStatus,
  onClose,
  allStatus,
  setAllStatus,
  selectedIndex,
  setProvidedItems,
}) => {
  const [showStatus, setShowStatus] = useState(false);
  const [filteredStatus, setFilteredStatus] = useState([]);
  const [addNew, setAddNew] = useState("Add-New");

  useEffect(() => {
    if (allStatus.length > 0) setFilteredStatus(allStatus);
  }, [allStatus]);

  return (
    <div
      style={{
        display: !openStatus && "none",
        // position: "relative",
        padding: "5px 10px",
        backgroundColor: "#fafafa",
        borderRadius: 10,
        fontSize: 12,
        width: 150,
        position: "absolute",
        bottom: "-10px",
      }}
    >
      {/* <IconButton /> */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginLeft: "10px",
        }}
      >
        <input
          placeholder="Search"
          style={{
            backgroundColor: "transparent",
            borderWidth: 0,
            width: 100,
          }}
          onChange={(e) => {
            const collectValues = [...allStatus];
            setFilteredStatus(
              collectValues.filter((val) =>
                val.toLowerCase().includes(e.target.value.toLocaleLowerCase()),
              ),
            );
          }}
        />
        {showStatus ? (
          <ExpandLess
            onClick={() => setShowStatus(false)}
            sx={{ cursor: "pointer" }}
          />
        ) : (
          <ExpandMore
            onClick={() => setShowStatus(true)}
            sx={{ cursor: "pointer" }}
          />
        )}
      </div>
      {showStatus && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "10px",
            color: "black",
            opacity: "0.8",
          }}
        >
          {[...filteredStatus].map((status, index) => {
            return (
              <div
                key={index}
                style={{
                  cursor: "pointer",
                  marginLeft: "10px",
                  width: "100%",
                }}
                onClick={() => {
                  setProvidedItems((prev) => {
                    const existing = [...prev];
                    existing[selectedIndex]["status"] = status;
                    return existing;
                  });
                  onClose();
                }}
              >
                {status}
              </div>
            );
          })}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
            }}
          >
            <input
              value={addNew}
              style={{
                backgroundColor: "transparent",
                borderWidth: 0,
                width: "70%",
                marginLeft: "10px",
                color: addNew === "Add-New" && "#00246a",
                fontWeight: addNew === "Add-New" && 600,
              }}
              onClick={() => setAddNew("")}
              onChange={(e) => setAddNew(e.target.value)}
            />
            {addNew !== "Add-New" && addNew !== "" && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <Check
                  sx={{
                    height: "15px",
                    width: "15px",
                    color: "#00246a",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setAllStatus((prev) => [...prev, addNew]);
                    setAddNew("Add-New");
                  }}
                />
                <CloseIcon
                  sx={{
                    height: "15px",
                    width: "15px",
                    color: "#00246a",
                    cursor: "pointer",
                  }}
                  onClick={() => setAddNew("Add-New")}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

// TIME OFF

export const TimeOffScreen = ({
  timeOffEntries,
  setTimeOffEntries,
  FetchUserData,
}) => {
  const dispatch = useDispatch();

  const deleteUserTimeOffRes = useSelector(
    (state) => state.user.deleteUserTimeOffRes,
  );

  const [openTimeOff, setOpenTimeOff] = useState(false);
  const [selectedUser, setSelectedUser] = useState([]);
  const [fileEnter, setFileEnter] = useState(false);
  const [index, setIndex] = useState(null);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Co-Workers").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const addNewEntry = (newEntry) => {
    setTimeOffEntries([...timeOffEntries, newEntry]);
  };

  useEffect(() => {
    if (FetchUserData && FetchUserData.length > 0) {
      setSelectedUser(new Array(FetchUserData).fill(false));
    }
  }, [FetchUserData]);

  // pdf download start
  const pdfdownload = (documentid, documentname) => {
    axios({
      method: "post",
      url: `${API_URL}/api/Files/DownloadToS3?documentid=` + documentid,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
      // data: {
      //   message?.message
      // },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      // var el = document.createElement('div');
      const document = window.document || {};
      const link = document.createElement("a");
      link.href = url;
      link.download = documentname;
      document.body.appendChild(link);
      link.click();
      // link.setAttribute("download", `FinalDocument.pdf`);
      // Append to html link element page
      // document.body.appendChild(link);
      // Start download
      // link.click();
      // Clean up and remove the link
      // link.parentNode.removeChild(link);
      // return docFileDownload;
      // }, 1000)
    });
  };
  // pdf download end

  useEffect(() => {
    // deleteUserTimeOffRes
  }, []);

  return (
    <>
      <Box sx={{ margin: "auto", padding: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Button
            // variant="contained"
            startIcon={
              <AddIcon
                sx={{
                  backgroundColor: "#E8EAF6",
                  borderRadius: "50%",
                  "&:hover": { backgroundColor: "#C5CAE9" },
                }}
              />
            }
            onClick={() => setOpenTimeOff(true)}
            sx={{
              color: "#333333",
              fontWeight: 300,
              backgroundColor: "white",
              "&:hover": { backgroundColor: "white" },
            }}
          >
            {/* Add Time-Off */}
            {t("Add Time-Off")}
          </Button>
          {openTimeOff && (
            <TimeOffEntryPopover
              open={openTimeOff}
              onClose={() => setOpenTimeOff(false)}
              addEntry={addNewEntry}
              usersList={FetchUserData}
              selectedUser={selectedUser}
              setSelectedUser={setSelectedUser}
              timeOffEntries={timeOffEntries}
              index={index}
              setIndex={setIndex}
              setTimeOffEntries={setTimeOffEntries}
            />
          )}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body2" sx={{ mr: 1 }}>
              {`1-${timeOffEntries?.length} of ${timeOffEntries?.length}`}
            </Typography>
            <IconButton size="small">
              <NavigateBeforeIcon />
            </IconButton>
            <IconButton size="small">
              <NavigateNextIcon />
            </IconButton>
          </Box>
        </Box>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="time off table">
            <TableHead>
              <TableRow>
                <TableCell>
                  {/* Type  */}
                  {t("Wage rate")}
                </TableCell>
                <TableCell>
                  {/* Starting Date */}
                  {t("Starting Date")}
                </TableCell>
                <TableCell>
                  {/* Last Day */}
                  {t("Last Day")}
                </TableCell>
                <TableCell>
                  {/* Total Days */}
                  {t("Total Days")}
                </TableCell>
                <TableCell>%</TableCell>
                <TableCell>
                  {/* Status */}
                  {t("Status")}
                </TableCell>
                <TableCell>
                  {/* File */}
                  {t("File")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {timeOffEntries.map((entry, index) => (
                <TableRow key={index}>
                  <TableCell
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      setOpenTimeOff(true);
                      setIndex(index);
                    }}
                  >
                    {entry.type}
                  </TableCell>
                  <TableCell>
                    {entry.startingDate
                      ? moment(entry.startingDate).format("DD-MM-YYYY")
                      : ""}
                  </TableCell>
                  <TableCell>
                    {entry.lastDay
                      ? moment(entry.lastDay).format("DD-MM-YYYY")
                      : ""}
                  </TableCell>
                  <TableCell>
                    {moment(entry.lastDay).diff(entry.startDate)
                      ? Math.abs(
                          moment(entry.lastDay).diff(
                            moment(entry.startDate),
                            "days",
                          ),
                        )
                      : ""}
                  </TableCell>
                  <TableCell>{entry.percent}</TableCell>
                  <TableCell
                    sx={{
                      color:
                        (entry.status === "Requested" ||
                          entry.status === "Refused") &&
                        "red",
                    }}
                  >
                    {entry.status}
                  </TableCell>
                  <TableCell
                    onMouseEnter={() => setFileEnter(true)}
                    onMouseLeave={() => setFileEnter(false)}
                  >
                    <IconButton size="small">
                      {entry.file && entry.filename && (
                        <FilePdfOutlined
                          onClick={() => {
                            console.log("asc timeoff", entry);
                            if (!entry.file) return;
                            pdfdownload(
                              entry.file,
                              entry.filename,
                              entry.fileurl,
                            );
                          }}
                        />
                      )}
                    </IconButton>
                    {fileEnter && (
                      <img
                        style={{ cursor: "pointer", height: 14, width: 14 }}
                        size={24}
                        src={del}
                        alt=""
                        onClick={() => {
                          setTimeOffEntries(
                            timeOffEntries.filter((time, i) => i !== index),
                          );

                          if (entry.userTimeOffid) {
                            dispatch(DeleteUserTimeOff(entry.userTimeOffid));
                          }
                        }}
                      />
                    )}
                  </TableCell>
                  {/* <TableCell>{entry.filename}</TableCell> */}
                </TableRow>
              ))}
              {timeOffEntries.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    {/* No time-off entries */}
                    {t("No time-off entries")}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

const TimeOffDropdown = ({ onSelect, selectedOption, setSelectedOption }) => {
  const [isOpen, setIsOpen] = useState(false);

  const [options, setOptions] = useState([
    "Vacations",
    "Illness",
    "Seek Leave",
    "Absence by Pregnancy (compensated)",
    "Maternity Leave",
    "Adoption/Foster care",
    "Mobility issues",
  ]);
  const [newOption, setNewOption] = useState("");
  const [isAddingNew, setIsAddingNew] = useState(false);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Co-Workers").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option) => {
    setSelectedOption(option.length > 20 ? option.slice(0, 20) : option);
    onSelect(option);
    setIsOpen(false);
  };

  const handleAddNewClick = () => {
    setIsAddingNew(true);
    setNewOption("");
  };

  const handleNewOptionChange = (e) => {
    setNewOption(e.target.value);
  };

  const handleNewOptionSubmit = () => {
    if (newOption.trim()) {
      setOptions([...options, newOption.trim()]);
      onSelect(newOption.trim());
      setSelectedOption(newOption.trim());
      setIsAddingNew(false);
      setIsOpen(false);
    }
  };

  const handleNewOptionCancel = () => {
    setIsAddingNew(false);
  };

  const styles = {
    container: {
      flexBasis: "48%",
      position: "relative",
    },
    label: {
      position: "absolute",
      top: "-10px",
      left: 8,
      fontSize: 11,
      color: "#666",
      marginBottom: "4px",
      backgroundColor: "white",
      padding: "0 10px",
    },
    select: {
      width: "100%",
      padding: "10px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      backgroundColor: "white",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
    },
    arrow: {
      borderStyle: "solid",
      borderWidth: "0 2px 2px 0",
      display: "inline-block",
      padding: "3px",
      transform: isOpen ? "rotate(-135deg)" : "rotate(45deg)",
      transition: "transform 0.2s",
    },
    dropdown: {
      position: "absolute",
      top: "100%",
      left: 0,
      right: 0,
      backgroundColor: "white",
      border: "1px solid #ccc",
      borderTop: "none",
      borderRadius: "0 0 4px 4px",
      maxHeight: "300px",
      overflowY: "auto",
      zIndex: 1000,
    },
    option: {
      padding: "4px 10px",
      cursor: "pointer",
      fontSize: 12,
      "&:hover": {
        backgroundColor: "#f0f0f0",
      },
    },
    addNew: {
      padding: "10px",
      color: "#00246a",
      cursor: "pointer",
      fontWeight: 600,
      // borderTop: "1px solid #ccc",
    },
    newOption: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    newOptionInput: {
      width: "100%",
      padding: "10px",
      border: "none",
    },
    newOptionActions: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.label}>
        {/* Type of Time-Off */}
        {t("Type of Time-Off")}
      </div>
      <div style={styles.select} onClick={toggleDropdown}>
        {/* <span>{selectedOption || "Select"}</span> */}
        <span>{selectedOption || t("Select ")}</span>
        <i style={styles.arrow}></i>
      </div>
      {isOpen && (
        <div style={styles.dropdown}>
          {options?.map((option, index) => (
            <div
              key={index}
              style={styles.option}
              onClick={() => handleOptionClick(option)}
            >
              {option}
            </div>
          ))}
          {isAddingNew ? (
            <div style={styles.newOption}>
              <input
                style={styles.newOptionInput}
                type="text"
                value={newOption}
                onChange={handleNewOptionChange}
                // placeholder="Enter new option"
                placeholder={t("Enter new option")}
                autoFocus
              />
              <div style={styles.newOptionActions}>
                <Check
                  sx={{ height: 14, width: 14 }}
                  onClick={handleNewOptionSubmit}
                />
                <CloseIcon
                  sx={{ height: 14, width: 14 }}
                  onClick={handleNewOptionCancel}
                />
              </div>
            </div>
          ) : (
            <div style={styles.addNew} onClick={handleAddNewClick}>
              {/* Add new... */}
              {t("Add New")}...
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const TimeOffPopoverContent = memo(
  ({
    addEntry,
    usersList,
    selectedUser,
    setSelectedUser,
    onClose,
    timeOffEntries,
    index,
    setIndex,
    setTimeOffEntries,
    selectedDate,
  }) => {
    const [timeOffType, setTimeOffType] = useState("");
    const [timeOffAddNew, setTimeOffAddNew] = useState("Add New");
    // const [startDate, setStartDate] = useState(new Date(selectedDate));
    const [startDate, setStartDate] = useState(new Date());
    const [lastDay, setLastDay] = useState("");
    const [justification, setJustification] = useState("");
    const [absence, setAbsence] = useState("");
    const [status, setStatus] = useState("Requested");
    const [file, setFile] = useState("");
    const [manager, setManager] = useState("");
    const [selectedOption, setSelectedOption] = useState("");
    const fileRef = useRef();
    const [loading, setLoading] = useState(false);
    const [filePresent, setFilePresent] = useState(false);
    const [openUsersList, setOpenUsersList] = useState(false);

    const FormField = styled(TextField)(({ theme }) => ({
      "& .MuiOutlinedInput-root": {
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper,
        "& fieldset": {
          borderColor: theme.palette.divider,
        },
      },
    }));
    const [FetchTranslationList, setFetchTranslationList] = useState({});
    const t = (key) => FetchTranslationList?.[key] || "";
    useEffect(() => {
      fetchScreenTranslations("Add-Co-Workers").then((data) =>
        setFetchTranslationList(data),
      );
    }, []);

    const handleAdd = () => {
      const newEntry = {
        type: timeOffType,
        startingDate: startDate,
        lastDay,
        justification,
        percent: absence,
        status,
        file,
        manager,
      };
      addEntry(newEntry);
      setIndex(null);
      onClose();
    };

    const handleUpdate = () => {
      const entry = {
        type: timeOffType,
        startingDate: startDate,
        lastDay,
        justification,
        percent: absence,
        status,
        file,
        manager,
      };
      setTimeOffEntries((prev) => {
        const existing = [...prev];
        existing[index] = entry;
        return existing;
      });
      setIndex(null);
      onClose();
    };

    useEffect(() => {
      if (index !== null && timeOffEntries[index]) {
        setTimeOffType(timeOffEntries[index]?.["type"]);
        setSelectedOption(timeOffEntries[index]?.["type"]);
        setStartDate(
          timeOffEntries[index]?.["startingDate"]
            ? new Date(timeOffEntries[index]?.["startingDate"])
            : "",
        );
        setLastDay(
          timeOffEntries[index]?.["lastDay"]
            ? new Date(timeOffEntries[index]?.["lastDay"])
            : "",
        );
        setJustification(timeOffEntries[index]?.["justification"]);
        setAbsence(timeOffEntries[index]?.["percent"]);
        setStatus(timeOffEntries[index]?.["status"]);
        setManager(timeOffEntries[index]?.["manager"]);
        setFile(timeOffEntries[index]?.["file"]);
      }
    }, [index]);

    const uploadFile = async () => {
      if (fileRef.current.files?.[0]) {
        setFilePresent(true);
      }
      const file = fileRef.current.files[0];
      const formData = new FormData();
      formData.append("file", file);
      try {
        setLoading(true);
        const response = await axios.post(
          `${API_URL}/api/Files/InsertDocToS3`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        let docid;
        let link;
        if (response?.status === 200) {
          docid = response?.data?.[0]?.data?.documentid;
          link = response?.data?.[0]?.data?.link;
          setFile(response?.data?.[0]?.data?.documentid);
        }
      } catch (err) {
        console.log(err);
      }
    };

    useEffect(() => {
      if (selectedUser.length > 0) {
        setManager(selectedUser?.[0]?.userid);
      }
    }, [selectedUser]);

    return (
      <>
        <Box sx={{ position: "relative" }}>
          <IconButton
            aria-label="close"
            sx={{
              position: "absolute",
              right: "-10px",
              top: "-10px",
              // padding: 2,
            }}
          >
            <CloseIcon
              onClick={onClose}
              sx={{
                height: "14px",
                width: "14px",
                border: "1px solid #a5a5a5",
                borderRadius: "50%",
              }}
            />
          </IconButton>
          <Typography variant="h6" component="h2" gutterBottom>
            {/* Time-Off Entry */}
            {t("Time-Off Entry")}
          </Typography>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(3,1fr)",
              gap: 2,
            }}
          >
            <Box sx={{ gridColumn: "1 / 3" }}>
              <TimeOffDropdown
                onSelect={(option) => setTimeOffType(option)}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
              />
            </Box>

            <CustomDate
              // label="Start date"
              label={t("Start date")}
              value={startDate}
              onChange={(e) => setStartDate(e)}
            />

            <Box sx={{ gridColumn: "1 / 3", height: "8rem" }}>
              <CustomTextField
                // label="Justification"
                label={t("Justification")}
                value={justification}
                multiline
                rows={5}
                onChange={(e) => setJustification(e.target.value)}
                sx={{ height: "auto" }}
              />
            </Box>
            <Box
              sx={{
                gridColumn: "3 / 4",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 2,
              }}
            >
              <CustomDate
                // label="Last day"
                label={t("Last day")}
                value={lastDay}
                onChange={(e) => setLastDay(e)}
              />

              <CustomTextField
                // label="Absence"
                label={t("Absence")}
                value={absence}
                onChange={(e) => setAbsence(e.target.value)}
                sx={{ flexBasis: "48%" }}
              />
              <FormField
                select
                // label="Status"
                label={t("Status")}
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                sx={{ flexBasis: "48%" }}
              >
                <MenuItem value="">
                  {/* Select */}
                  {t("Select ")}
                </MenuItem>
                <MenuItem value="Approved">
                  {/* Approved */}
                  {t("Approved")}
                </MenuItem>
                <MenuItem value="Refused">
                  {/* Refused */}
                  {t("Refused")}
                </MenuItem>
                <MenuItem value="Requested">
                  {/* Requested */}
                  {t("Requested")}
                </MenuItem>
                <MenuItem value="Pending">
                  {/* Pendent */}
                  {t("Pending")}
                </MenuItem>
              </FormField>
            </Box>
            <input
              type="file"
              ref={fileRef}
              className="d-none"
              onChange={uploadFile}
              style={{ gridColumn: "1/3" }}
            />
            <Box
              sx={{
                gridColumn: "3 / 4",
              }}
            >
              <FormField
                // label="Manager"
                label={t("Manager")}
                value={
                  selectedUser.length > 0
                    ? selectedUser?.map((user) => {
                        return user?.firstname;
                      })
                    : ""
                }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AddIcon
                        sx={{ cursor: "pointer" }}
                        onClick={() => {
                          setOpenUsersList(true);
                        }}
                      />
                    </InputAdornment>
                  ),
                }}
                sx={{ flexBasis: "48%" }}
              />
            </Box>
          </Box>

          <Button
            variant="text"
            startIcon={filePresent ? <Check /> : <AddIcon />}
            sx={{
              color: "#00246A",
              fontSize: "14px",
              fontWeight: "500",
              mt: 2,
              backgroundColor: "white",
              marginTop: "-60px",
              "&:hover": { backgroundColor: "white" },
            }}
            onClick={() => {
              if (fileRef.current) fileRef.current.click();
            }}
          >
            {/* {filePresent ? "Added" : "Add justification doc"} */}
            {filePresent ? "Added" : t("Add justification doc")}
          </Button>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Button
              variant="contained"
              sx={{ width: "100px" }}
              onClick={index !== null ? handleUpdate : handleAdd}
            >
              {index !== null ? "Update" : "Add"}
            </Button>
          </Box>
        </Box>

        <AssigneeModal
          // isBuildingBlock={props.isBuildingBlock}
          modalOpen={openUsersList}
          modalHideEv={() => setOpenUsersList(false)}
          selectedUsers={selectedUser}
          setSelectedUsers={(data) => {
            setSelectedUser(data?.filter((entity) => entity.assigneeid));
          }}
        />
      </>
    );
  },
);

export const TimeOffEntryPopover = ({
  open,
  addEntry,
  onClose,
  usersList,
  selectedUser,
  setSelectedUser,
  timeOffEntries,
  index,
  setIndex,
  setTimeOffEntries,
  selectedDate,
}) => {
  const StyledPopover = styled(Popover)(({ theme }) => ({
    "& .MuiPopover-paper": {
      padding: theme.spacing(3),
      width: 600,
      borderRadius: theme.shape.borderRadius,
    },
  }));

  return (
    <Modal
      open={open}
      closeIcon={null}
      footer={null}
      onCancel={() => onClose()}
      width={530}
    >
      <TimeOffPopoverContent
        addEntry={addEntry}
        usersList={usersList}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        onClose={onClose}
        timeOffEntries={timeOffEntries}
        index={index}
        setIndex={setIndex}
        setTimeOffEntries={setTimeOffEntries}
        selectedDate={selectedDate}
      />
    </Modal>
  );
};

const UsersListContent = ({
  usersList,
  selectedUser,
  setSelectedUser,
  setManager,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "10px",
        maxHeight: "200px",
        overflow: "scroll",
        fontSize: 13,
        fontWeight: 500,
        width: "100%",
        // maxWidth: "100px",
      }}
    >
      {usersList &&
        usersList.length > 0 &&
        usersList.map((user, index) => {
          return (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                padding: "5px 20px 0 0",
                position: "relative",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <input
                  type="checkbox"
                  // checked={item.checked}
                  className="form-check-input pointer companyRadio ms-"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  checked={selectedUser[index]}
                  onChange={(e) => {
                    if (selectedUser[index]) {
                      setSelectedUser(new Array(usersList).fill(false));
                      setManager("");
                    } else {
                      const newUsersList = new Array(usersList).fill(false);
                      newUsersList[index] = true;
                      setSelectedUser(newUsersList);
                      setManager(usersList?.[index]?.roleid);
                    }
                  }}
                />

                <img
                  src={user?.imageurl}
                  alt=""
                  style={{
                    height: "20px",
                    width: "20px",
                    borderRadius: "50%",
                  }}
                />
                <Box>{`${user?.firstname} ${user?.lastname}`}</Box>
              </Box>
              <Box sx={{ width: "80px" }}>{user?.rolename}</Box>
              {selectedUser[index] && (
                <Check
                  sx={{
                    position: "absolute",
                    right: 0,
                    height: 15,
                    width: 15,
                    opacity: 0.8,
                  }}
                />
              )}
            </Box>
          );
        })}
    </Box>
  );
};

const MemberPopOver = ({
  usersList,
  openUsersList,
  onClose,
  selectedUser,
  setSelectedUser,
  setManager,
}) => {
  return (
    <Modal
      open={openUsersList}
      onCancel={() => onClose()}
      centered
      // anchorOrigin={{
      //   vertical: "bottom",
      //   horizontal: "center",
      // }}
      // closeIcon={null}
      width={400}
      footer={null}
      height={300}
      style={{ maxHeight: "300px" }}
    >
      <UsersListContent
        usersList={usersList}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        setManager={setManager}
      />
    </Modal>
  );
};
